import Swup from "swup";
import SwupBodyClassPlugin from '@swup/body-class-plugin'

export function runSwup({
	Nette,
    EventBus, 
    EVENTS,
    ScrollService,
    scrollToElement,
    loadComponents,
    removeComponents,
	scrollHistory,
	setScrollPosition,
	runScriptsInsideElement,
	isNativeScroll,
	NajaService,
}) {
    if (!Nette || !EventBus || !ScrollService || !EVENTS || !scrollToElement || !loadComponents || !removeComponents || !scrollHistory || !setScrollPosition || !runScriptsInsideElement || !isNativeScroll || !NajaService) {
        console.error('Dependencies required to run swup')
        return
    }

    const swup = new Swup({
		linkSelector: [
			'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not([target="_blank"]):not(.ajax):not([download]):not([data-component])',
			'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not(.ajax):not([download]):not([data-component])',
		].join(', '),
        containers: ['#swup', '#modals', '#sojern', '#fixed-header-leftcontent', '#popup-nav-main', '#popup-nav-footer'],
		animationSelector: '#swup',
		plugins: [new SwupBodyClassPlugin()],
	})

	swup.hooks.on('link:click', (event) => {
		EventBus.emit(EVENTS.SWUP_CLICK_LINK, { event })
        scrollHistory.saveCurrent()
	})

	swup.hooks.on('visit:start', (visit) => {
		const els = [...document.querySelectorAll(visit.containers.join(','))] 
		els.forEach((element) => {
			removeComponents(element)
		})
	})

	swup.hooks.on('link:self', () => {
		scrollToElement(document.querySelector('.Header'), {
			mode: 'force'
		})
	})

	swup.hooks.on('content:replace', (visit) => {
		if (isNativeScroll()) {
            ScrollService.useNative()
        } else {
            ScrollService.useVirtual()
                .catch(() => ScrollService.useNative())
        }

		Nette.reinit()

		const els = [...document.querySelectorAll(visit.containers.join(','))] 
		els.forEach((element) => {
			loadComponents(element)
			NajaService.uiHandler.bindUI(element)
			//na bookine a voucherpage poustet scripty rovnou a necekat na komponenty
			if (document.body.classList.contains('booking-Page') || document.body.classList.contains('voucher-Page')) {
				runScriptsInsideElement(element)
			}
			//poustet sojern scripty po swupu na kazdy strance
			const sojernEl = document.getElementById('sojern')
			if (sojernEl) {
				runScriptsInsideElement(sojernEl)
			}
		})


        if (ScrollService) {
            ScrollService.resize()

			const historyState = scrollHistory.getCurrent()
			if (historyState) {
				setScrollPosition(historyState.scroll.x, historyState.scroll.y)
			} else {
				setScrollPosition(0,0)
			}

            document.body.style.height = ``
        }

		EventBus.emit(EVENTS.SWUP_CONTENT_REPLACED)
	})

	swup.hooks.on('history:popstate', () => {
		const historyState = scrollHistory.getCurrent()
        if (historyState) {
            document.body.style.height = `${historyState.height}px`
        }
	})
}
